// extracted by mini-css-extract-plugin
export var container = "_4h-0";
export var disabled = "_4h-4";
export var fullWidth = "_4h-3";
export var lined = "_4h-1";
export var selected = "_4h-5";
export var tab = "_4h-2";